<script>
  import { DateTime } from 'luxon';

  export let block;
  export let grid;
  export let user;

  let tooltipX = 0;
	let tooltipY = 0;

  const getDays = (item) => {
    const start = DateTime.fromISO(item.dateFrom, { setZone: true });
    const end   = DateTime.fromISO(item.dateTo, { setZone: true });

		return end.diff(start, 'days').toObject().days;
	}

  const getTextPadding = (item) => {
    const length = getDays(item);
    const offset = getOffset(item.dateFrom);

    const left  = offset < 0 && offset + length > 0 ? Math.abs(offset) * 51 - 26 : 0;
    const right = offset + length > grid.length ? (offset + length - grid.length) * 51 + 26 : 0;

    return { right: right, left: left };
  };

  const getOffset = (date) => {
    const start = DateTime.fromISO(date, { setZone: true });

    if (grid.length === 0) return 0;

    const gridStart = grid[0].date.setZone('utc', { keepLocalTime: true });

    return start.diff(gridStart, 'days').toObject().days;
  };

  const handleMouseOver = (e) => {
		tooltipX = e.clientX;
		tooltipY = e.clientY;
	}

  const width   = getDays(block) * 51 - 2;
  $: padding = getTextPadding(block, grid);
  $: offset  = getOffset(block.dateFrom, grid) * 51 + 26;
</script>

<div on:mousemove={handleMouseOver}
  class='item' class:hostBooking='{block.blockReason === 'Host booking' || block.blockReason === 'Friend of host booking'}'
  style='width: {width}px;  left: {offset}px; top: {10 + (50 * (block.row - 1))}px;'
  class:cleaner='{user.accountRole.toLowerCase() === 'cleaner'}'
  >
  <div class='item-name ' style='padding-left: {padding.left}px;padding-right: {padding.right}px'>
    {block.blockType}
    </div>
  <span class='tip'  style='left: {tooltipX}px; top:{tooltipY}px'>
    <p class='blue-font'><b>{DateTime.fromISO(block.dateFrom,{setZone : true}).toLocaleString()} - {DateTime.fromISO(block.dateTo,{setZone : true}).toLocaleString()}</b></p>
    <p class='blue-font'><b>Inserted: </b>{DateTime.fromISO(block.dateInserted,{setZone:true}).toLocaleString(DateTime.DATETIME_SHORT)}</p>
    <p class='blue-font'>{block.nights} nights</p>
    <p class='name'><b>Block Type: </b> {block.blockType}</p>
    {#if block.blockReason}<p class='name'><b>Block Reason: </b> {block.blockReason}</p>{/if}
    {#if block.owner}<p class='name'><b>Block Owner: </b> {block.owner}</p>{/if}
  </span>
</div>

<style>
  .item {
		position: absolute;
		left: 0;
		height:30px;
		text-align: center;
		font-size:11px;
		color:white;
		line-height: 30px;
		font-style: italic;
		background-color: #D0CECF;
		border-radius: 15px;
		text-transform: uppercase;
	}

  .tip {
		font-style: normal;
		text-transform: none;
		text-align: left;
		border: 1px solid #D0CFCB;
		background-color: white;
		position: fixed;
		padding: 10px;
		z-index: 5;
		display: none;
		width:200px;
		transform: translateX(-50%) translateY(-120%);
		color:black;
		font-size:13px;
		line-height:20px;
		font-weight:normal;
	}
	.tip p{
		margin:0;
	}
	.tip p.name{
		font-size:14px;
		margin:4px 0;
	}

  .item:hover .tip {
		display: block;
	}

	.tip::before{
		width: 0;
		height: 0;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-top: 10px solid #D0CFCB;
		content: " ";
		position: absolute;
		bottom:-10px;
		left:100px;
	}

	.tip::after{
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-top: 9px solid white;
		content: " ";
		position: absolute;
		bottom:-9px;
		left:102px;
	}

  .item.cleaner:hover .tip, .item.cleaner {
    display: none;
  }
  .item.hostBooking{
        color : black;
        background-color: #FFFFFF;
        border:2px red solid;
        white-space: nowrap;
        overflow: hidden;
  }
</style>
